/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js';
import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from 'app/app.module';
import {environment} from './environments/environment';
import {boolDevFlag, devFlagHelp, DevFlags} from 'test-helpers/dev-flags';

if (environment.production) {
    enableProdMode();
}
if (!boolDevFlag(DevFlags.EnableDebugLog, !environment.production)) {
    console.debug = () => null;
}

devFlagHelp();

// @ts-ignore
(window.__polyfillsLoaded || Promise.resolve())
    .then(() => platformBrowserDynamic().bootstrapModule(AppModule))
    .catch(err => console.error(err));
